import { createFileRoute, Navigate } from '@tanstack/react-router';
import { useIsMobileShell } from '@/shared/mobile/useIsMobileShell';
import { MobileTaskNew } from '@/features/tasks/mobile/MobileTaskNew';

export const Route = createFileRoute('/_app/tasks/new')({
  validateSearch: (s: Record<string, unknown>): { status?: string } => ({
    status: typeof s.status === 'string' ? s.status : undefined,
  }),
  component: TaskNewPage,
});

/**
 * Form «Nuovo task» solo mobile. Su desktop la creazione è il pannello della sezione
 * (`?task=new`), e chi arriva qui ci viene mandato dal layout `tasks.tsx` prima che questo
 * componente sia montato — il `<Navigate>` è il ripiego se un domani l'`Outlet` coprisse la rotta.
 */
function TaskNewPage() {
  const isMobile = useIsMobileShell();
  const { status } = Route.useSearch();
  return isMobile ? <MobileTaskNew status={status} /> : <Navigate to="/tasks" search={{ task: 'new' }} replace />;
}
